import CellModalPopup from './cell_modal_popup';

export default CellModalPopup;
